import { render, staticRenderFns } from "./SalesRevenue.vue?vue&type=template&id=5d063fdf&scoped=true&"
import script from "./SalesRevenue.vue?vue&type=script&lang=js&"
export * from "./SalesRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d063fdf",
  null
  
)

export default component.exports